export const VIDEO_WATCH_PATH = '/en/videos/dangerous-goods-transport-auditor';
export const FRENCH_GLOBAL_VIDEO_WATCH_PATH = '/videos/palen-ia-transport-marchandises-dangereuses';
export const PALEN_V14_ENGLISH_VIDEO_WATCH_PATH = '/en/videos/palen-ai-dangerous-goods';
export const PALEN_V14_FRENCH_VIDEO_WATCH_PATH = '/videos/palen-ia-matieres-dangereuses';
export const ADR_SECONDS_VIDEO_WATCH_PATH = '/videos/reponses-adr-en-quelques-secondes';
export const VIDEO_WATCH_PATHS = [
  VIDEO_WATCH_PATH,
  FRENCH_GLOBAL_VIDEO_WATCH_PATH,
  PALEN_V14_ENGLISH_VIDEO_WATCH_PATH,
  PALEN_V14_FRENCH_VIDEO_WATCH_PATH,
  ADR_SECONDS_VIDEO_WATCH_PATH,
] as const;

export function isVideoWatchPath(pathname: string): boolean {
  return (VIDEO_WATCH_PATHS as readonly string[]).includes(pathname);
}

export function isPalenV14VideoWatchPath(pathname: string): boolean {
  return pathname === PALEN_V14_ENGLISH_VIDEO_WATCH_PATH
    || pathname === PALEN_V14_FRENCH_VIDEO_WATCH_PATH;
}

export const VIDEO_WATCH_ASSETS = {
  desktop: '/assets/marketing/videos/en/palen-dangerous-goods-transport-auditor-desktop.mp4',
  mobile: '/assets/marketing/videos/en/palen-dangerous-goods-transport-auditor-mobile.mp4',
  captions: '/assets/marketing/videos/en/palen-dangerous-goods-transport-auditor-en.vtt',
  thumbnail: '/assets/marketing/en/yotuube.png',
} as const;

export const FRENCH_GLOBAL_VIDEO_WATCH_ASSETS = {
  video: '/assets/marketing/videos/fr/palen-ia-transport-marchandises-dangereuses.mp4',
  thumbnail: '/assets/marketing/linkedin_cover.png',
} as const;

export const PALEN_V14_ENGLISH_VIDEO_WATCH_ASSETS = {
  desktop: '/assets/marketing/videos/en/palen-dangerous-goods-ai-presentation-60s-16x9.mp4',
  mobile: '/assets/marketing/videos/en/palen-dangerous-goods-ai-presentation-60s-1x1.mp4',
  thumbnail: '/assets/marketing/en/yotuube.png',
} as const;

export const PALEN_V14_FRENCH_VIDEO_WATCH_ASSETS = {
  desktop: '/assets/marketing/videos/fr/palen-ia-matieres-dangereuses-presentation-60s-16x9.mp4',
  mobile: '/assets/marketing/videos/fr/palen-ia-matieres-dangereuses-presentation-60s-1x1.mp4',
  thumbnail: '/assets/marketing/linkedin_cover.png',
} as const;

export const ADR_SECONDS_VIDEO_WATCH_ASSETS = {
  video: '/assets/marketing/videos/fr/palen-reponses-adr-a3c1450d18f1.mp4',
  thumbnail: '/assets/marketing/videos/fr/palen-reponses-adr-poster.webp',
} as const;

const ORIGIN = 'https://palen-adr.eu';
const VIDEO_URL = `${ORIGIN}${VIDEO_WATCH_PATH}`;
const FRENCH_GLOBAL_VIDEO_URL = `${ORIGIN}${FRENCH_GLOBAL_VIDEO_WATCH_PATH}`;
const PALEN_V14_ENGLISH_VIDEO_URL = `${ORIGIN}${PALEN_V14_ENGLISH_VIDEO_WATCH_PATH}`;
const PALEN_V14_FRENCH_VIDEO_URL = `${ORIGIN}${PALEN_V14_FRENCH_VIDEO_WATCH_PATH}`;

// Use midnight UTC when only the publication day is known; uploadDate requires a DateTime.
export const VIDEO_WATCH_SEO = {
  title: 'Palen dangerous goods transport audit agent — Video',
  description: 'See how Palen helps analyse a dangerous goods transport and identify applicable regulatory obligations, including ADR requirements where they apply.',
  url: VIDEO_URL,
  uploadDate: '2026-09-23T00:00:00Z',
  duration: 'PT1M18S',
  desktopUrl: `${ORIGIN}${VIDEO_WATCH_ASSETS.desktop}`,
  mobileUrl: `${ORIGIN}${VIDEO_WATCH_ASSETS.mobile}`,
  thumbnailUrl: `${ORIGIN}${VIDEO_WATCH_ASSETS.thumbnail}`,
  language: 'en',
  locale: 'en_US',
  imageWidth: 2560,
  imageHeight: 1440,
  imageAlt: 'Palen dangerous goods at a glance',
} as const;

export const FRENCH_GLOBAL_VIDEO_WATCH_SEO = {
  title: "Palen, l'IA experte du transport de Marchandises Dangereuses — Vidéo",
  description: 'Questions réglementaires et scénarios de transport : Palen analyse les textes officiels applicables, identifie les exigences à respecter et livre une réponse claire, précise et sourcée.',
  url: FRENCH_GLOBAL_VIDEO_URL,
  uploadDate: '2026-09-24T00:00:00Z',
  duration: 'PT2M2S',
  contentUrl: `${ORIGIN}${FRENCH_GLOBAL_VIDEO_WATCH_ASSETS.video}`,
  thumbnailUrl: `${ORIGIN}${FRENCH_GLOBAL_VIDEO_WATCH_ASSETS.thumbnail}`,
  language: 'fr',
  locale: 'fr_FR',
  imageWidth: 1983,
  imageHeight: 793,
  imageAlt: 'Palen, IA experte du transport de Marchandises Dangereuses',
} as const;

export const PALEN_V14_ENGLISH_VIDEO_WATCH_SEO = {
  title: 'Palen, the AI specialist in Dangerous Goods — Video',
  description: 'See how Palen answers dangerous goods questions and analyses a transport in seconds, with applicable rules, possible exemptions and verifiable sources.',
  url: PALEN_V14_ENGLISH_VIDEO_URL,
  uploadDate: '2026-10-02T00:00:00Z',
  duration: 'PT1M',
  contentUrl: `${ORIGIN}${PALEN_V14_ENGLISH_VIDEO_WATCH_ASSETS.desktop}`,
  thumbnailUrl: `${ORIGIN}${PALEN_V14_ENGLISH_VIDEO_WATCH_ASSETS.thumbnail}`,
  language: 'en',
  locale: 'en_US',
  imageWidth: 2560,
  imageHeight: 1440,
  imageAlt: 'Palen, the AI specialist in Dangerous Goods',
} as const;

export const PALEN_V14_FRENCH_VIDEO_WATCH_SEO = {
  title: "Palen, l'IA spécialiste de la Matière Dangereuse — Vidéo",
  description: 'Découvrez comment Palen répond aux questions sur les matières dangereuses et analyse un transport en quelques secondes, avec des sources vérifiables.',
  url: PALEN_V14_FRENCH_VIDEO_URL,
  uploadDate: '2026-10-02T00:00:00Z',
  duration: 'PT1M',
  contentUrl: `${ORIGIN}${PALEN_V14_FRENCH_VIDEO_WATCH_ASSETS.desktop}`,
  thumbnailUrl: `${ORIGIN}${PALEN_V14_FRENCH_VIDEO_WATCH_ASSETS.thumbnail}`,
  language: 'fr',
  locale: 'fr_FR',
  imageWidth: 1983,
  imageHeight: 793,
  imageAlt: "Palen, l'IA spécialiste de la Matière Dangereuse",
} as const;

export const ADR_SECONDS_VIDEO_WATCH_SEO = {
  title: 'Palen, vos réponses ADR en quelques secondes — Vidéo',
  description: 'Une question ADR, une exemption à vérifier ou un transport à préparer ? Découvrez Palen, une IA spécialisée avec des réponses fiables et des sources vérifiables.',
  url: `${ORIGIN}${ADR_SECONDS_VIDEO_WATCH_PATH}`,
  uploadDate: '2026-10-22T00:00:00Z',
  duration: 'PT33.033333S',
  contentUrl: `${ORIGIN}${ADR_SECONDS_VIDEO_WATCH_ASSETS.video}`,
  thumbnailUrl: `${ORIGIN}${ADR_SECONDS_VIDEO_WATCH_ASSETS.thumbnail}`,
  language: 'fr',
  locale: 'fr_FR',
  imageWidth: 1280,
  imageHeight: 720,
  imageAlt: 'Palen, des réponses ADR fiables et des sources vérifiables',
} as const;

type VideoWatchSeo = {
  title: string;
  description: string;
  url: string;
  uploadDate: string;
  duration: string;
  contentUrl: string;
  thumbnailUrl: string;
  language: 'en' | 'fr';
  locale: 'en_US' | 'fr_FR';
  imageWidth: number;
  imageHeight: number;
  imageAlt: string;
};

export function buildVideoWatchStructuredData() {
  return buildStructuredData({ ...VIDEO_WATCH_SEO, contentUrl: VIDEO_WATCH_SEO.desktopUrl });
}

export function buildFrenchGlobalVideoWatchStructuredData() {
  return buildStructuredData(FRENCH_GLOBAL_VIDEO_WATCH_SEO);
}

export function buildAdrSecondsVideoWatchStructuredData() {
  return buildStructuredData(ADR_SECONDS_VIDEO_WATCH_SEO);
}

function buildStructuredData(seo: VideoWatchSeo) {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        '@id': `${ORIGIN}/#organization`,
        name: 'Palen',
        url: `${ORIGIN}/`,
        logo: `${ORIGIN}/assets/logo/palen_public.png`,
      },
      {
        '@type': 'WebPage',
        '@id': `${seo.url}#webpage`,
        name: seo.title,
        description: seo.description,
        url: seo.url,
        inLanguage: seo.language,
        mainEntity: { '@id': `${seo.url}#video` },
        publisher: { '@id': `${ORIGIN}/#organization` },
      },
      {
        '@type': 'VideoObject',
        '@id': `${seo.url}#video`,
        name: seo.title,
        description: seo.description,
        thumbnailUrl: [seo.thumbnailUrl],
        uploadDate: seo.uploadDate,
        duration: seo.duration,
        contentUrl: seo.contentUrl,
        inLanguage: seo.language,
        isFamilyFriendly: true,
        publisher: { '@id': `${ORIGIN}/#organization` },
      },
    ],
  } as const;
}

export function buildVideoWatchSeoHeadMarkup(): string {
  return buildSeoHeadMarkup(
    { ...VIDEO_WATCH_SEO, contentUrl: VIDEO_WATCH_SEO.desktopUrl },
    buildVideoWatchStructuredData(),
  );
}

export function buildFrenchGlobalVideoWatchSeoHeadMarkup(): string {
  return buildSeoHeadMarkup(
    FRENCH_GLOBAL_VIDEO_WATCH_SEO,
    buildFrenchGlobalVideoWatchStructuredData(),
  );
}

export function buildPalenV14EnglishVideoWatchStructuredData() {
  return buildStructuredData(PALEN_V14_ENGLISH_VIDEO_WATCH_SEO);
}

export function buildPalenV14FrenchVideoWatchStructuredData() {
  return buildStructuredData(PALEN_V14_FRENCH_VIDEO_WATCH_SEO);
}

export function buildPalenV14EnglishVideoWatchSeoHeadMarkup(): string {
  return buildSeoHeadMarkup(
    PALEN_V14_ENGLISH_VIDEO_WATCH_SEO,
    buildPalenV14EnglishVideoWatchStructuredData(),
    PALEN_V14_FRENCH_VIDEO_WATCH_SEO.url,
  );
}

export function buildPalenV14FrenchVideoWatchSeoHeadMarkup(): string {
  return buildSeoHeadMarkup(
    PALEN_V14_FRENCH_VIDEO_WATCH_SEO,
    buildPalenV14FrenchVideoWatchStructuredData(),
    PALEN_V14_ENGLISH_VIDEO_WATCH_SEO.url,
  );
}

export function buildAdrSecondsVideoWatchSeoHeadMarkup(): string {
  return buildSeoHeadMarkup(
    ADR_SECONDS_VIDEO_WATCH_SEO,
    buildAdrSecondsVideoWatchStructuredData(),
  );
}

function buildSeoHeadMarkup(
  seo: VideoWatchSeo,
  structuredData: unknown,
  alternateUrl?: string,
): string {
  const alternateLanguage = seo.language === 'en' ? 'fr' : 'en';
  return `
    <!-- PALEN_SEO_HEAD_START -->
    <title>${seo.title}</title>
    <meta name="description" content="${seo.description}" />
    <meta name="robots" content="index,follow,max-image-preview:large,max-video-preview:-1" />
    <link rel="canonical" href="${seo.url}" />
    <link rel="alternate" hreflang="${seo.language}" href="${seo.url}" />
    ${alternateUrl ? `<link rel="alternate" hreflang="${alternateLanguage}" href="${alternateUrl}" />` : ''}
    <link rel="alternate" hreflang="x-default" href="${seo.url}" />
    <meta property="og:type" content="video.other" />
    <meta property="og:site_name" content="Palen" />
    <meta property="og:title" content="${seo.title}" />
    <meta property="og:description" content="${seo.description}" />
    <meta property="og:url" content="${seo.url}" />
    <meta property="og:image" content="${seo.thumbnailUrl}" />
    <meta property="og:image:width" content="${seo.imageWidth}" />
    <meta property="og:image:height" content="${seo.imageHeight}" />
    <meta property="og:image:alt" content="${seo.imageAlt}" />
    <meta property="og:video" content="${seo.contentUrl}" />
    <meta property="og:video:type" content="video/mp4" />
    <meta property="og:video:width" content="1920" />
    <meta property="og:video:height" content="1080" />
    <meta property="og:locale" content="${seo.locale}" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="${seo.title}" />
    <meta name="twitter:description" content="${seo.description}" />
    <meta name="twitter:image" content="${seo.thumbnailUrl}" />
    <meta name="twitter:image:alt" content="${seo.imageAlt}" />
    <script id="video-watch-structured-data" type="application/ld+json">${serializeStructuredData(structuredData)}</script>
    <!-- PALEN_SEO_HEAD_END -->`;
}

function serializeStructuredData(value: unknown): string {
  return JSON.stringify(value).replace(/</g, '\\u003c');
}
